













































































import {Vue, Component} from "vue-property-decorator"

@Component({})
export default class App extends Vue {

  onLogout(){
    localStorage.removeItem('session')
    this.$router.push('/login')
    this.$forceUpdate()
  }

}

